import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { getTriviaFileName } from "../data";
import { withFolderQuery } from "../Components/backNav";
import LibraryQuestions from "./LibraryQuestions";
import LibraryTrivvys from "./LibraryTrivvys";
import { connect } from "react-redux";
import Loading from "../../../hoc/Loading/Loading";
import ReactTooltip from "react-tooltip";
import * as actionCreators from "../../../modules/actions";

function TriviaLibraryViewPage({ updateLibraryTrivvyCount, ...props }) {
  const [libraryDoc, setLibraryDoc] = useState(null);
  const [menu, setMenu] = useState(1);
  const [libQuestions,setLibQuestions] = useState([])
  const [isLibraryUnavailable, setIsLibraryUnavailable] = useState(false);

  let opt2 = 'trivvys'
  let opt1 = 'questions'

  const updateLibraryDoc=(data)=>{
    setLibraryDoc(data)
  }


  useEffect(() => {
    const libraryId = props.match.params.id;
    const tab = props.match.params.tab;
    if (tab === opt1) {
      setMenu(1);
    }
    if (tab === opt2) {
      setMenu(2);
    }
    axios.get(url.getTriviaLibraryById(libraryId)).then(({ data }) => {
      setLibraryDoc(data.data);
      updateLibraryTrivvyCount({
        typeTrivvy: "SET",
        valueTrivvy: data.data.triviaCount,
      });
    }).catch((error) => {
      // Missing, deleted or not visible to this user (TBV-938).
      console.log(error);
      setIsLibraryUnavailable(true);
    });
  }, []);

  useEffect(() => {

    const tab = props.match.params.tab;
    if (tab === opt1) {
      setMenu(1);
    }
    if (tab === opt2) {
      setMenu(2);
    }

    const libraryId = props.match.params.id;
    axios.get(url.getTriviaLibraryById(libraryId)).then(({ data }) => {
      setLibraryDoc(data.data);
      updateLibraryTrivvyCount({
        typeTrivvy: "SET",
        valueTrivvy: data.data.triviaCount,
      });
    }).catch((error) => {
      // Missing, deleted or not visible to this user (TBV-938).
      console.log(error);
      setIsLibraryUnavailable(true);
    });
  }, [props.match.params.tab]);

  const selectMenu = num => {
    if (num === 1) {
      props.history.push(opt1);
    }
    if (num === 2) {
      props.history.push(opt2);
    }
    setMenu(num);
  };

  return (
    <div className="trivia_survey_edit_page">
      {isLibraryUnavailable && (
        <div className="text-center mt-5">
          <h5>This Library item is not available.</h5>
          <p className="text-muted">It may have been removed, or you may not have access to it.</p>
        </div>
      )}
      {libraryDoc && props.user && (
        <div>
          <div className={`survey-top-div ${!isMobile && "pl-3"}`}>
            <Row
              className={`survey_detail_page_top_navbar bg-white ${
                isMobile ? "mx-0" : "pl-1"
              }`}
              style={{left:"18px"}}
            >
              <Col md={9}>
                <div className="d-flex align-items-center">
                  <span
                    className="survey_detail_page_top_wp"
                    onClick={() => {
                      props.history.push(
                        withFolderQuery(
                          `/home/trivia/${props.user.profile.organizationId._id}/library`,
                          libraryDoc.folderId
                        )
                      );
                    }}
                  >
                    Library -{" "}
                  </span>
                  <span
                    className="survey-item-title"
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    data-tip={getTriviaFileName({
                      uploadUrl: libraryDoc.s3Url,
                      uploadFileName: libraryDoc.s3Key,
                      showFull: true,
                      librarySourceType:libraryDoc.librarySourceType,
                      libName:libraryDoc.name,
                      webUrl: libraryDoc.webUrl

                    })}
                    data-for="trivvy_lib_title"
                  >
                    {getTriviaFileName({
                      uploadUrl: libraryDoc.s3Url,
                      uploadFileName: libraryDoc.s3Key,
                      librarySourceType:libraryDoc.librarySourceType,
                      libName:libraryDoc.name
                    })}
                  </span>
                  <ReactTooltip id="trivvy_lib_title" place="right" />
                </div>
              </Col>
            
            </Row>
          </div>
          <div>
            <div
              className={isMobile ? "px-2" : ""}
              style={{
                position: "relative",
                top: isMobile ? "60px" : "40px",
              }}
            >
              {menu == 2 ? (
                 <LibraryTrivvys updateLibraryDoc={updateLibraryDoc} libQuestions={libQuestions} library={libraryDoc} />
              ) : menu == 1 ? (
                <LibraryTrivvys updateLibraryDoc={updateLibraryDoc} libQuestions={libQuestions} library={libraryDoc} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLibraryTrivvyCount: data =>
      dispatch(actionCreators.updateSingleLibrarayStatsForTrivvyCount(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaLibraryViewPage, axios));
